import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try { await api.post("/auth/forgot-password", { email }); setDone(true); }
        catch (er) { toast.error(formatApiError(er.response?.data?.detail)); }
        finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
            <form onSubmit={submit} className="w-full max-w-md bg-white rounded-lg border border-slate-200 p-8 space-y-6">
                <h1 className="font-display text-2xl font-semibold tracking-tight">Recuperar contraseña</h1>
                {done ? (
                    <div className="text-sm text-slate-600">Si el email existe, recibirás un enlace para restablecer tu contraseña.</div>
                ) : (
                    <>
                        <div><Label>Correo</Label><Input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="forgot-email"/></div>
                        <Button type="submit" className="w-full" disabled={busy} data-testid="forgot-submit">{busy?"Enviando...":"Enviar enlace"}</Button>
                    </>
                )}
                <div className="text-sm text-center"><Link to="/login" className="text-orange-600">Volver a iniciar sesión</Link></div>
            </form>
        </div>
    );
}

export function ResetPassword() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const token = params.get("token") || "";
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await api.post("/auth/reset-password", { token, password });
            toast.success("Contraseña restablecida");
            navigate("/login");
        } catch (er) { toast.error(formatApiError(er.response?.data?.detail)); }
        finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
            <form onSubmit={submit} className="w-full max-w-md bg-white rounded-lg border border-slate-200 p-8 space-y-6">
                <h1 className="font-display text-2xl font-semibold tracking-tight">Nueva contraseña</h1>
                <div><Label>Contraseña</Label><Input type="password" required minLength={6} value={password} onChange={(e)=>setPassword(e.target.value)} data-testid="reset-password-input"/></div>
                <Button type="submit" className="w-full" disabled={busy || !token} data-testid="reset-submit">{busy?"Guardando...":"Restablecer"}</Button>
                <div className="text-sm text-center"><Link to="/login" className="text-orange-600">Volver a iniciar sesión</Link></div>
            </form>
        </div>
    );
}
